import * as React from "react";
import { useField } from "formik";
import IconPlus from "../Icons/IconPlus";

interface InputFile {
  name: string;
  fileSet: () => void;
}

const InputFile: React.FC<InputFile> = (props: InputFile) => {
  const { name, fileSet } = props;
  const [fileNameString, setFileNameString] = React.useState("");

  React.useEffect(() => {
    if (fileNameString && fileNameString.length > 0) {
      fileSet();
    }
  }, [fileSet, fileNameString]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helpers] = useField(name);

  return (
    <fieldset className="mt-3 mb-4 lg:max-w-1/2">
      <label htmlFor={name} className="text-s text-dw-grey-09 font-bold">
        Upload file *
        <div className="p-3 mt-2 bg-dw-grey-02 cursor-pointer flex items-center max-w-full relative">
          <p className="text-dw-grey-07 font-bold text-xs truncate max-w-1/2 md:max-w-2/3">
            {fileNameString || "Your File"}
          </p>
          <p className="text-dw-grey-07 font-normal text-xs inline-block ml-1">
            (max 50 MB)
          </p>
          <IconPlus
            className="absolute"
            style={{ right: "15px", width: "16px", height: "auto" }}
          />
        </div>
        <input
          type="file"
          id="file"
          className="hidden"
          name={name}
          required
          accept=".resilience"
          onChange={(e) => {
            if (e.currentTarget.files) {
              const file = e.currentTarget.files[0];
              const { name: fileName, size } = file;

              setFileNameString(fileName);

              helpers.setValue({
                name: fileName,
                size,
                file,
              });
            }
          }}
        />
      </label>
    </fieldset>
  );
};

export default InputFile;
